import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function Footer({ data }) {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="mt-12 pt-6 text-sm text-slate-600">
      <motion.div
        className="rounded-xl bg-slate-50 dark:bg-slate-900 shadow-sm ring-1 ring-slate-200/70 dark:ring-slate-700 px-6 py-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <p>
          © {new Date().getFullYear()} {data.name}. Securing innovation and scaling resilience — a journey through my
          career in cybersecurity.
        </p>
      </motion.div>

      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 no-print rounded-full px-4 py-2 bg-[#1E3A8A] dark:bg-[#A7C7E7] text-white dark:text-slate-900 shadow hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#A7C7E7]"
          aria-label="Back to top"
        >
          Top
        </button>
      )}
    </footer>
  );
}
